"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportAgentToJSON = exports.SupportAgentFromJSONTyped = exports.SupportAgentFromJSON = void 0;
function SupportAgentFromJSON(json) {
    return SupportAgentFromJSONTyped(json, false);
}
exports.SupportAgentFromJSON = SupportAgentFromJSON;
function SupportAgentFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SupportAgentFromJSONTyped = SupportAgentFromJSONTyped;
function SupportAgentToJSON(value) {
    return value;
}
exports.SupportAgentToJSON = SupportAgentToJSON;
